import { render, staticRenderFns } from "./defaultContent.vue?vue&type=template&id=650bd54d&scoped=true&"
import script from "./defaultContent.vue?vue&type=script&lang=js&"
export * from "./defaultContent.vue?vue&type=script&lang=js&"
import style0 from "./defaultContent.vue?vue&type=style&index=0&id=650bd54d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650bd54d",
  null
  
)

export default component.exports